import { createContext, useContext } from "react";

/**
 * The app theme. Light is the default. Dark is a user setting. The app does
 * not follow the OS colour scheme (design system README, "Internal apps").
 */
export type Theme = "light" | "dark";

export interface ThemeContextValue {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  /** The applied theme. It is always equal to `theme`. */
  resolvedTheme: Theme;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);

export function useTheme(): ThemeContextValue {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error("useTheme must be used within a <ThemeProvider>");
  }
  return ctx;
}
